var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
import { Api } from "../../constants/modules/api.constants";
import { TokenClient } from "../authentication/token-client.service";
import * as Enumerable from "linq";
import { toNative } from "../../utilities/promise-utils";
var LotteryClientService = /** @class */ (function () {
    function LotteryClientService(requestClient, tokenClient) {
        this.requestClient = requestClient;
        this.tokenClient = tokenClient;
    }
    LotteryClientService.prototype.getLotteriesByBrand = function (brandId, getAll) {
        var _this = this;
        if (brandId === void 0) { brandId = null; }
        if (getAll === void 0) { getAll = false; }
        if (getAll || (this.tokenClient.isPreview && !this.tokenClient.user.brandId)) {
            // super admin preview: return all as BrandLotteryModel[]
            return new Promise(function (resolve, reject) {
                _this.getLotteries().then(function (xs) {
                    var list = Enumerable.from(xs)
                        .select(function (a) {
                        var lottery = {
                            lotteryId: a.lotteryId,
                            lottery: a,
                            lotteryAdditionalInfoId: null
                        };
                        return lottery;
                    })
                        .toArray();
                    resolve(list);
                }, reject);
            });
        }
        else if (this.tokenClient.isPreview && this.tokenClient.user.brandId) {
            return toNative(this.requestClient.get(Api.ManageLotteries.GetLotteriesByBrand, { brandId: this.tokenClient.user.brandId }));
        }
        return toNative(this.requestClient.get(Api.ManageLotteries.GetLotteriesByBrand, { brandId: brandId }));
    };
    LotteryClientService.prototype.getBundlesByBrand = function (brandId) {
        return toNative(this.requestClient.get(Api.ManageLotteries.GetBundlesByBrand, { brandId: brandId }));
    };
    LotteryClientService.prototype.getLotteries = function () {
        return toNative(this.requestClient.get(Api.ManageLotteries.GetAll, {}));
    };
    LotteryClientService.prototype.getLotteryDrawsInMonth = function (lotteryId) {
        return toNative(this.requestClient.get(Api.ManageLotteries.GetDrawsForLottery, { lotteryId: lotteryId }));
    };
    LotteryClientService.prototype.GetDrawsForMultipleLottery = function (lotteryIds) {
        return toNative(this.requestClient.get(Api.ManageLotteries.GetDrawsForMultipleLottery, { lotteryIds: lotteryIds }));
    };
    LotteryClientService.prototype.getLotteryDrawsForPeriod = function (lotteryId, brandId, operatorId) {
        return toNative(this.requestClient.get(Api.ManageLotteries.GetLotteryDrawsForPeriod, { lotteryId: lotteryId, brandId: brandId, operatorId: operatorId }));
    };
    LotteryClientService.prototype.getLotteriesInsuranceInfo = function (request) {
        // ✅ fix generic to match return type
        return toNative(this.requestClient.post(Api.ManageLotteries.GetLotteriesInsuranceInfo, {}, request));
    };
    LotteryClientService.prototype.getLotteryForAdmin = function (request) {
        return toNative(this.requestClient.get(Api.ManageLotteries.GetForAdmin, request));
    };
    LotteryClientService.prototype.getFeed = function (request) {
        return toNative(this.requestClient.get(Api.ManageLotteries.GetFeed, request));
    };
    LotteryClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(Api.ManageLotteries.Save, {}, request));
    };
    LotteryClientService.prototype.delete = function (request) {
        return toNative(this.requestClient.post(Api.ManageLotteries.Delete, {}, request));
    };
    LotteryClientService.prototype.calculatePrice = function (request) {
        return toNative(this.requestClient.post(Api.ManageLotteries.CalculatePrice, {}, request));
    };
    LotteryClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, TokenClient])
    ], LotteryClientService);
    return LotteryClientService;
}());
export { LotteryClientService };
